import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client5g',
  templateUrl: './client5g.component.html',
  styleUrls: ['./client5g.component.scss']
})
export class Client5gComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
